import {Select} from "@/theme/ui";
import {useApi} from "@/lib/hook";

export const RoleSelect = ({...rest}) => {
    const {data} = useApi({
        route: {name: 'authorization.roles'},
        data: {
            include: 'permissions',
        },
        setting: {
            select: (data) => data.role,
            staleTime: Infinity,
        }
    })

    return (
        <>
            <Select
                style={{
                    width: '100%',
                }}
                fieldNames={{value: 'name', label: 'name'}}
                options={data ?? []}
                {...rest}
            />
        </>
    );
}